var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PopupContent',{attrs:{"id":"mapPopup","graph-id":_vm.graphId,"show-chart":_vm.showPopupChart,"popup-details":_vm.popupDetails,"title-prop":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }